<template>
  <div>
    <base-nav
      v-model="showMenu"
      class="base-nav-desktop navbar-absolute top-navbar"
      type="white"
      :transparent="true"
    >
      <div slot="brand" class="navbar-wrapper">
        <div class="navbar-minimize d-inline">
          <sidebar-toggle-button />
        </div>
        <div
          class="navbar-toggle d-inline"
          :class="{ toggled: $sidebar.showSidebar }"
        >
          <button type="button" class="navbar-toggler" @click="toggleSidebar">
            <span class="navbar-toggler-bar bar1"></span>
            <span class="navbar-toggler-bar bar2"></span>
            <span class="navbar-toggler-bar bar3"></span>
            <span class="navbar-toggler-bar bar4"></span>
          </button>
        </div>

        <div
          v-if="$store.getters.systemTitleImage != null"
          class="simple-text logo-normal"
        >
          <img :src="$store.getters.systemTitleImage" alt="app-logo-Amaggi" />
          <a class="navbar-brand" href="#/module">{{ routeName }}</a>
        </div>
        <a v-else class="navbar-brand" href="#/module">{{ routeName }}</a>
      </div>

      <ul class="navbar-nav" :class="$rtl.isRTL ? 'mr-auto' : 'ml-auto'">
        <div v-if="isLoggedIn" class="form-group mr-2">
          <label class="mt-3"> Conectado como: </label>
        </div>
        <div class="form-group">
          <label class="mt-3">
            <b-link :href="getProfileUserUrl" class="check">
              <a> {{ getUserDisplayName }} | </a>
            </b-link>
          </label>
        </div>
        <div
          class="form-group"
          v-if="$store.getters.hasAccessCompany || userRms"
        >
          <label class="mt-3 ml-2">
            <b-link href="#" class="check" @click="openCompanyModal">
              <a> {{ getCompanyFantasyName }} | </a>
            </b-link>
          </label>
        </div>
        <div class="form-group" v-else>
          <label class="mt-3 ml-2"> {{ getCompanyFantasyName }} | </label>
        </div>
        <div class="form-group">
          <label class="mt-3 ml-2">
            <router-link to="/module" class="check">
              <a> {{ $t("geral.modules") }}</a>
            </router-link>
          </label>
        </div>
        <!-- notificação -->
        <!-- <div>
          <base-dropdown
            tag="li"
            title-tag="a"
            class="nav-item mt-3"
            title-classes="nav-item-notification"
            menu-classes="dropdown-navbar-notifications"
            :menu-on-right="!$rtl.isRTL"
          >
            <template slot="title">
              <i class="material-icons"
                ><span class="material-symbols-outlined">
                  notifications
                </span></i
              >
            </template>
          </base-dropdown>
        </div> -->

        <base-dropdown
          tag="li"
          :menu-on-right="!$rtl.isRTL"
          title-tag="a"
          class="nav-item"
          title-classes="nav-link"
          menu-classes="dropdown-navbar"
        >
          <template slot="title">
            <div class="photo">
              <img src="/img/mike.jpg" />
            </div>
            <b class="caret d-none d-lg-block d-xl-block"></b>
            <p class="d-lg-none">Log Out</p>
          </template>
          <li class="nav-link"></li>
          <li v-if="isLoggedIn" class="nav-link">
            <a :href="getProfileUserUrl" class="nav-item dropdown-item">{{
              $t("checklist.navbar.Profile")
            }}</a>
          </li>
          <div v-if="$store.getters.hasAccessCompany">
            <li v-if="isLoggedIn" class="nav-link">
              <a :href="getCompanyUrl" class="nav-item dropdown-item">{{
                $t("checklist.navbar.Company")
              }}</a>
            </li>
          </div>
          <div class="dropdown-divider"></div>
          <li class="nav-link">
            <label class="toggleLabel nav-item dropdown-item">
              Sidebar
              <base-switch
                class="toggleSwitch"
                v-model="sidebarMini"
                @input="minimizeSidebar"
              ></base-switch>
            </label>
          </li>
          <li class="nav-link nav-darkmode">
            <label class="toggleLabel nav-item dropdown-item">
              Dark mode
              <base-switch
                class="toggleSwitch"
                v-model="darkMode"
                @input="toggleMode"
              ></base-switch>
            </label>
          </li>
          <div v-if="isLoggedIn" class="dropdown-divider"></div>
          <li v-if="isLoggedIn" class="nav-link">
            <a @click.prevent="logout" class="nav-item dropdown-item">{{
              $t("checklist.navbar.LogOut")
            }}</a>
          </li>
        </base-dropdown>
      </ul>
    </base-nav>

    <base-nav
      v-model="showMenu"
      class="base-nav-mobile navbar-absolute top-navbar"
      type="white"
      :transparent="true"
    >
      <div slot="brand" class="navbar-wrapper">
        <div class="navbar-minimize d-inline">
          <sidebar-toggle-button />
        </div>
        <div
          class="navbar-toggle d-inline"
          :class="{ toggled: $sidebar.showSidebar }"
        >
          <button type="button" class="navbar-toggler" @click="toggleSidebar">
            <span class="navbar-toggler-bar bar1"></span>
            <span class="navbar-toggler-bar bar2"></span>
            <span class="navbar-toggler-bar bar3"></span>
            <span class="navbar-toggler-bar bar4"></span>
          </button>
        </div>
      </div>

      <ul class="navbar-nav" :class="$rtl.isRTL ? 'mr-auto' : 'ml-auto'">
        <div class="form-group">
          <label>
            <router-link to="/module" class="check">
              <a>{{ $t("geral.modules") }}</a>
            </router-link>
          </label>
        </div>
        <li v-if="isLoggedIn" class="nav-link ml-4 mb-2">
          {{ getCompanyFantasyName }}
          <!-- <a class="nav-item dropdown-item" style="color: black;">
            {{getCompanyFantasyName}}
          </a> -->
        </li>
        <li v-if="isLoggedIn" class="nav-link ml-4 mb-2">
          {{ getUserDisplayName }}
          <!-- <a class="nav-item dropdown-item" style="color: black;">
            {{getUserDisplayName}}
          </a> -->
        </li>
        <div class="dropdown-divider"></div>
        <div>
          <li v-if="isLoggedIn" class="nav-link">
            <a
              :href="getProfileUserUrl"
              class="nav-item dropdown-item"
              style="color: black"
              >{{ $t("checklist.navbar.Profile") }}</a
            >
          </li>
        </div>
        <div v-if="$store.getters.hasAccessCompany">
          <li v-if="isLoggedIn" class="nav-link">
            <a
              :href="getCompanyUrl"
              class="nav-item dropdown-item"
              style="color: black"
              >{{ $t("checklist.navbar.Company") }}</a
            >
          </li>
        </div>
        <div v-if="isLoggedIn" class="dropdown-divider"></div>
        <li class="nav-link">
          <router-link to="/module" class="check">
            <a class="nav-item dropdown-item" style="color: black">{{
              $t("geral.modulesSelection")
            }}</a>
          </router-link>
        </li>
        <div class="dropdown-divider"></div>
        <li class="nav-link nav-darkmode">
          <label class="toggleLabel nav-item dropdown-item">
            Dark mode
            <base-switch
              class="toggleSwitch"
              v-model="darkMode"
              @input="toggleMode"
            ></base-switch>
          </label>
        </li>
        <div v-if="isLoggedIn" class="dropdown-divider"></div>
        <li v-if="isLoggedIn" class="nav-link">
          <a
            @click.prevent="logout"
            class="nav-item dropdown-item"
            style="color: black"
            >{{ $t("checklist.navbar.LogOut") }}</a
          >
        </li>
        <!-- </base-dropdown> -->
      </ul>
    </base-nav>

    <company-modal ref="companyModal" :module="module"></company-modal>
  </div>
</template>
<script>
//import { CollapseTransition } from "vue2-transitions";
import { BaseNav, BaseSwitch, Modal } from "@/components";
import SidebarToggleButton from "./SidebarToggleButton";

export default {
  components: {
    SidebarToggleButton,
    //  CollapseTransition,
    BaseNav,
    BaseSwitch,
    Modal,
    CompanyModal: () =>
      import("@/components_rms/System/Company/CompanyModal.vue"),
  },
  props: {
    module: String,
    id: String,
  },
  computed: {
    getProfileUserUrl() {
      if (this.module == "checklist") return "/checklist/user/profile";
      else if (this.module == "trackingShippingCompany")
        return "/trackingShippingCompany/user/profile";
      else if (this.module == "BI") return "/bi/user/profile";
    },
    getCompanyUrl() {
      let getId = this.$store.getters.companyId;
      if (this.module == "checklist") return "/checklist/company/edit/" + getId;
      else if (this.module == "trackingShippingCompany")
        return "/trackingShippingCompany/company/edit/" + getId;
      else if (this.module == "BI") return "/bi/company/edit/" + getId;
    },

    getCompanyFantasyName() {
      return this.$store.getters.companyFantasyName;
    },
    getUserDisplayName() {
      return this.$store.getters.userDisplayname;
    },
    routeName() {
      const { name, meta } = this.$route;
      if (meta) if (meta.title) return this.capitalizeFirstLetter(meta.title);
      return this.capitalizeFirstLetter(name);
    },
    isRTL() {
      return this.$rtl.isRTL;
    },
    isLoggedIn: function () {
      return this.$store.getters.isLoggedIn;
    },
  },
  data() {
    return {
      activeNotifications: false,
      darkMode: true,
      showMenu: false,
      sidebarMini: true,
      searchModalVisible: false,
      searchQuery: "",
      userRms: false,
      hasNotifications: false,
    };
  },
  created() {
    this.sidebarMini = !this.$sidebar.isMinimized;
    this.isRmsUser();
  },
  beforeMount() {
    this.darkMode = this.$store.getters.darkmode;
    this.toggleModeStyle(this.darkMode);
  },
  methods: {
    async isRmsUser() {
      this.$apiScheduler.get("/user/isRms").then((response) => {
        this.userRms = response.data;
      });
    },
    openCompanyModal() {
      this.$refs.companyModal.openModal();
    },
    capitalizeFirstLetter(string) {
      return string.charAt(0).toUpperCase() + string.slice(1);
    },
    toggleNotificationDropDown() {
      this.activeNotifications = !this.activeNotifications;
    },
    closeDropDown() {
      this.activeNotifications = false;
    },
    minimizeSidebar() {
      this.$sidebar.toggleMinimize();
    },
    toggleSidebar() {
      this.$sidebar.displaySidebar(!this.$sidebar.showSidebar);
    },
    hideSidebar() {
      this.$sidebar.displaySidebar(false);
    },
    toggleMenu() {
      this.showMenu = !this.showMenu;
    },
    toggleMode(type) {
      this.$store.dispatch("darkmode", type);
      this.toggleModeStyle(type);
    },
    toggleModeStyle(type) {
      let docClasses = document.body.classList;
      if (type) {
        docClasses.remove("white-content");
      } else {
        docClasses.add("white-content");
      }
    },
    logout() {
      this.$store.dispatch("logout").then(() => {
        this.$router.push("/login");
      });
    },
  },
};
</script>
<style scoped>
.top-navbar {
  top: 0px;
}
.toggleLabel {
  min-width: 180px;
}
.toggleSwitch {
  position: absolute;
  right: 20px;
}
@media (max-width: 992px) {
  .base-nav-desktop {
    display: none;
  }
}

@media (min-width: 992px) {
  .base-nav-mobile {
    display: none;
  }
}
</style>
